module.exports = __webpack_public_path__ + "img/cafe_pc_100.0bde1c81.png";